import { useI18n } from "../i18n/I18nProvider";

interface Props {
  value: number;
  max: number;
  min?: number;
  onChange: (value: number) => void;
  label: string;
}

export function QuantityStepper({ value, max, min = 1, onChange, label }: Props) {
  const { t } = useI18n();
  return (
    <div className="stepper" role="group" aria-label={label}>
      <button type="button" aria-label={t("cart.decrease")} disabled={value <= min} onClick={() => onChange(value - 1)}>
        −
      </button>
      <output aria-live="polite">{value}</output>
      <button type="button" aria-label={t("cart.increase")} disabled={value >= max} onClick={() => onChange(value + 1)}>
        +
      </button>
    </div>
  );
}
